module.exports = __webpack_public_path__ + "static/media/upload.5e5e91ef.svg";